import { render, staticRenderFns } from "./education-tab.vue?vue&type=template&id=17cd5a56"
import script from "./education-tab.vue?vue&type=script&lang=js"
export * from "./education-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports